/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateYesterdaySleepWrapUpDto
 */
export interface UpdateYesterdaySleepWrapUpDto {
    /**
     * Sleep duration in minutes
     * @type {number}
     * @memberof UpdateYesterdaySleepWrapUpDto
     */
    minutes: number;
}

/**
 * Check if a given object implements the UpdateYesterdaySleepWrapUpDto interface.
 */
export function instanceOfUpdateYesterdaySleepWrapUpDto(value: object): value is UpdateYesterdaySleepWrapUpDto {
    if (!('minutes' in value) || value['minutes'] === undefined) return false;
    return true;
}

export function UpdateYesterdaySleepWrapUpDtoFromJSON(json: any): UpdateYesterdaySleepWrapUpDto {
    return UpdateYesterdaySleepWrapUpDtoFromJSONTyped(json, false);
}

export function UpdateYesterdaySleepWrapUpDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateYesterdaySleepWrapUpDto {
    if (json == null) {
        return json;
    }
    return {
        
        'minutes': json['minutes'],
    };
}

export function UpdateYesterdaySleepWrapUpDtoToJSON(json: any): UpdateYesterdaySleepWrapUpDto {
    return UpdateYesterdaySleepWrapUpDtoToJSONTyped(json, false);
}

export function UpdateYesterdaySleepWrapUpDtoToJSONTyped(value?: UpdateYesterdaySleepWrapUpDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'minutes': value['minutes'],
    };
}

